import React, { useEffect } from 'react';

import { DashboardHomeTabType } from '../home/constants';
import useDashboardStore from '../store/dashboard';

const useDashboardActiveTab = (tab: DashboardHomeTabType) => {
  const activeTab = useDashboardStore((state) => state.activeTab);
  const setActiveTab = useDashboardStore((state) => state.setActiveTab);

  useEffect(() => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  }, [activeTab, setActiveTab, tab]);
};

export default useDashboardActiveTab;
